import handleNavItemHide from '../filter-flyout/handleNavItemHide';
/**
 * Returns a callback to update the selected state of the
 * component based on a single checked input.
 * @param {Element} select
 * @returns {Function} A callback function
 */
const handleSingleSelection = (select) => (e) => {
    const target = e.type === 'load'
        ? $(select).find('input:checked').get(0)
        : e.target;

    if (!target) return;

    $(select).find('input:checked')
        .filter((_, input) => input !== target)
        .prop('checked', false);

    const label = target.checked
        ? $(target).siblings('label').text()
        : $(select).attr('data-placeholder');

    $(select).find('.select__head__label').text(label);

    $(select).attr('data-selected', target.checked);
    handleNavItemHide(false);
};

export default handleSingleSelection;



// WEBPACK FOOTER //
// ./src/scripts/components/select/handleSingleSelection.js